import React from "react";

// Style
import "./ErrorPage.scss";

// Components
import Navbar from "../../components/common/Navbar";

const ErrorPage = (props) => {
  return (
    <div className="component-error-page">
      <Navbar />
      <div>404</div>
    </div>
  );
};

export default ErrorPage;
